export const constant = {
  // Deployed builds (dev site, prod site) use a relative base URL that
  // resolves against whatever origin served the page, so one build works in
  // every environment with no hand-editing. Local development (npm run
  // start-client, where CRA fixes NODE_ENV to 'development') talks straight
  // to the local API server on :3001, exactly as before.
  baseUrl: process.env.NODE_ENV === 'development' ? 'http://127.0.0.1:3001/api/' : '/api/'
}
